module.exports = __webpack_public_path__ + "section/burger/img/ico-lang.svg?hash=927c14a41d367dbf6c4df0bb9ba41071"


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/asset-loader!./LeLab.LogAlto.Web/src/modules/section/burger/img/ico-lang.svg
 ** module id = 18
 ** module chunks = 0 1
 **/